import React from 'react';
import PropTypes from 'prop-types';

import './index.scss';

export default function FormCheckboxLegacy({label, required, value, onChange}) {
    return (
        <label className="form-checkbox-legacy layout-row">
            <input
                className="form-checkbox-legacy__input"
                type="checkbox"
                checked={value}
                onChange={onChange}
            />
            <div className="form-checkbox-legacy__label">
                {label}
                {
                    required
                        ? <span className="form-checkbox-legacy__required">(required)</span>
                        : null
                }
            </div>
        </label>
    );
}

FormCheckboxLegacy.defaultProps = {
    inline: true
};

FormCheckboxLegacy.propTypes = {
    label: PropTypes.string,
    required: PropTypes.bool,
    value: PropTypes.bool,
    onChange: PropTypes.func
};



// WEBPACK FOOTER //
// ./components/form_checkbox_legacy/index.js